// Giữ mã nước ở value để dropdown hiển thị tên nhưng payload gửi đúng mã 2 ký tự cho BE.
export const manufacturingCountryOptions = [
  { value: 'AD', label: 'Andorran' },
  { value: 'KT', label: 'Christmas Islan' },
  { value: 'AE', label: 'Utd.Arab Emir.' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'AG', label: 'Antigua/Barbuda' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'LA', label: 'Lào' },
  { value: 'AL', label: 'An Ba Ni' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'AM', label: 'Armenia' },
  { value: 'LC', label: 'St. Lucia' },
  { value: 'AN', label: 'Netherlands Antilles' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'AO', label: 'Angola' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'LQ', label: 'Palmyra Atoll' },
  { value: 'AR', label: 'Argentina' },
  { value: 'LR', label: 'Liberia' },
  { value: 'AS', label: 'Samoa, America' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'AT', label: 'Áo' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'AU', label: 'Úc' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'AW', label: 'Aruba' },
  { value: 'LV', label: 'Latvia' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'LY', label: 'LiBi' },
  { value: 'BA', label: 'Bosnia-Herz.' },
  { value: 'MA', label: 'Morocco' },
  { value: 'BB', label: 'Barbados' },
  { value: 'MC', label: 'Monaco' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'MD', label: 'Moldova' },
  { value: 'BE', label: 'Bỉ' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'BG', label: 'Bun Ga Ri' },
  { value: 'MH', label: 'Marshall Islands' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'MK', label: 'Macedonia' },
  { value: 'BI', label: 'Burundi' },
  { value: 'ML', label: 'Mali' },
  { value: 'BJ', label: 'Benin' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'BL', label: 'SaintBarthélemy' },
  { value: 'MN', label: 'Mông Cổ' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'MO', label: 'Macau' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'BQ', label: 'Navassa Island' },
  { value: 'MR', label: 'Mauretania' },
  { value: 'BR', label: 'Brazil' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'MT', label: 'Malta' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'BV', label: 'Bouvet Islands' },
  { value: 'MV', label: 'Maldives' },
  { value: 'BW', label: 'Botswana' },
  { value: 'MW', label: 'Malawi' },
  { value: 'BY', label: 'Belarus' },
  { value: 'MX', label: 'Mexico' },
  { value: 'BZ', label: 'Belize' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'CA', label: 'Ca na da' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'CC', label: 'Coconut Islands' },
  { value: 'NA', label: 'Namibia' },
  { value: 'CD', label: 'Dem. Rep. Congo' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'CF', label: 'CAR' },
  { value: 'NE', label: 'Niger' },
  { value: 'CG', label: 'Rep.of Congo' },
  { value: 'NF', label: 'Norfolk Islands' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'CI', label: 'Cote d\'Ivoire' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'NL', label: 'Hà Lan' },
  { value: 'CL', label: 'Chile' },
  { value: 'NO', label: 'Norway' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'NP', label: 'Nepal' },
  { value: 'CN', label: 'Trung Quốc' },
  { value: 'NR', label: 'Nauru' },
  { value: 'CO', label: 'Columbia' },
  { value: 'NT', label: 'NATO' },
  { value: 'CP', label: 'Channel Islands' },
  { value: 'NU', label: 'Niue' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'CS', label: 'Serbia/Monten.' },
  { value: 'OC', label: 'Other Country' },
  { value: 'CU', label: 'Cuba' },
  { value: 'OM', label: 'Oman' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'OR', label: 'Orange' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'PA', label: 'Panama' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'PE', label: 'Peru' },
  { value: 'CZ', label: 'Cộng Hòa Séc' },
  { value: 'PF', label: 'Frenc.Polynesia' },
  { value: 'DE', label: 'Đức' },
  { value: 'PG', label: 'Pap. New Guinea' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'PH', label: 'Philippin' },
  { value: 'DK', label: 'Đan Mạch' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'DM', label: 'Dominica' },
  { value: 'PL', label: 'Ba Lan' },
  { value: 'DO', label: 'Dominican Rep.' },
  { value: 'PM', label: 'St.Pier, Miquel.' },
  { value: 'DQ', label: 'Jarvis Island' },
  { value: 'PN', label: 'Pitcairn Islands' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'PS', label: 'Palestine' },
  { value: 'EE', label: 'Estonia' },
  { value: 'PT', label: 'Bồ Đào Nha' },
  { value: 'EG', label: 'Egypt' },
  { value: 'PW', label: 'Palau' },
  { value: 'EH', label: 'West Sahara' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'QA', label: 'Qatar' },
  { value: 'ES', label: 'Tây Ban Nha' },
  { value: 'RE', label: 'Reunion' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'RO', label: 'Ru Ma Ni' },
  { value: 'EU', label: 'European Union' },
  { value: 'RS', label: 'Serbia' },
  { value: 'FI', label: 'Finland' },
  { value: 'RU', label: 'Nga' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'FK', label: 'Falkland Islands' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'FQ', label: 'Baker Island' },
  { value: 'SD', label: 'Sudan' },
  { value: 'FR', label: 'Pháp' },
  { value: 'SE', label: 'Thụy Điển' },
  { value: 'FS', label: 'French Southern' },
  { value: 'SG', label: 'Singapore' },
  { value: 'FX', label: 'France, Metropo' },
  { value: 'SH', label: 'Saint Helena' },
  { value: 'GA', label: 'Gabon' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'GB', label: 'Anh' },
  { value: 'SJ', label: 'Svalbard' },
  { value: 'GD', label: 'Grenada' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'GF', label: 'French Guayana' },
  { value: 'SM', label: 'San Marino' },
  { value: 'GH', label: 'Ghana' },
  { value: 'SN', label: 'Senegal' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'SO', label: 'Somalia' },
  { value: 'GK', label: 'Guernsey' },
  { value: 'SR', label: 'Suriname' },
  { value: 'GL', label: 'Greenland' },
  { value: 'ST', label: 'S.Tome,Principe' },
  { value: 'GM', label: 'Gambia' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GN', label: 'Guinea' },
  { value: 'SY', label: 'Syria' },
  { value: 'GO', label: 'Glorioso Island' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'TC', label: 'Turksh Caicosin' },
  { value: 'GQ', label: 'Equatorial Guin' },
  { value: 'TD', label: 'Chad' },
  { value: 'GR', label: 'Greece' },
  { value: 'TE', label: 'Tromelin Island' },
  { value: 'GS', label: 'S. Sandwich Ins' },
  { value: 'TF', label: 'French S.Territ' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'TG', label: 'Togo' },
  { value: 'GU', label: 'Guam' },
  { value: 'TH', label: 'Thái Lan' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'GY', label: 'Guyana' },
  { value: 'TK', label: 'Tokelau Islands' },
  { value: 'GZ', label: 'Gaza Strip' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'HM', label: 'Heard/McDon.Isl' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'HN', label: 'Honduras' },
  { value: 'TO', label: 'Tonga' },
  { value: 'HQ', label: 'Howland Island' },
  { value: 'TP', label: 'East Timor' },
  { value: 'HR', label: 'Croatia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'HT', label: 'Haiti' },
  { value: 'TT', label: 'Trinidad,Tobago' },
  { value: 'HU', label: 'Hung ga ri' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'TW', label: 'Đài Loan' },
  { value: 'IE', label: 'Ailen (Ireland)' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'IL', label: 'Israel' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'UC', label: 'Unknown Country' },
  { value: 'IN', label: 'Ấn Độ' },
  { value: 'UE', label: 'United Arab Emi' },
  { value: 'IO', label: 'Brit.Ind.Oc.Ter' },
  { value: 'UG', label: 'Uganda' },
  { value: 'IP', label: 'Clipperton Isla' },
  { value: 'UM', label: 'Minor Outl.Isl.' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'UN', label: 'United Nations' },
  { value: 'IR', label: 'Iran' },
  { value: 'US', label: 'Hoa kỳ' },
  { value: 'IS', label: 'Iceland' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'IT', label: 'I ta li a' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'JA', label: 'Japan Ryukyu' },
  { value: 'VA', label: 'Vatican City' },
  { value: 'JE', label: 'Jersey' },
  { value: 'VC', label: 'St. Vincent' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'JN', label: 'Jan Mayen' },
  { value: 'VG', label: 'Brit.Virgin Is.' },
  { value: 'JO', label: 'Jordan' },
  { value: 'VI', label: 'Amer.Virgin Is.' },
  { value: 'JP', label: 'Nhật' },
  { value: 'VN', label: 'Việt Nam' },
  { value: 'JQ', label: 'Johnston Atoll' },
  { value: 'VP', label: 'Corsica' },
  { value: 'JU', label: 'Juan de Nova Is' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'KE', label: 'Kenya' },
  { value: 'WF', label: 'Wallis và Futuna' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'WS', label: 'Samoa' },
  { value: 'KH', label: 'Cămpuchia' },
  { value: 'YE', label: 'Yemen' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'KM', label: 'Comoros' },
  { value: 'YU', label: 'Serbia &Mtnegro' },
  { value: 'KN', label: 'St Kitts&Nevis' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KP', label: 'Bắc Triều Tiên' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'KQ', label: 'Kingman Reef' },
  { value: 'ZW', label: 'Zimbabwe' },
  { value: 'KR', label: 'Hàn Quốc' },
  { value: 'ZZ', label: 'Khác' },
] as const;
